import React from 'react';
import PropTypes from 'prop-types';

import './Caption.sass';

export default function Caption({children}) {
  return (
    <div className="caption">
      {children}
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/caption/Caption.js